<template>
  <v-app-bar :height=headerheight class="wgu-app-toolbar onprimary--text" color="primary" fixed app clipped-left
    clipped-right>

    <!-- slot to inject components at the beginning (before title) -->
    <slot name="wgu-tb-start"></slot>

    <!--
    <v-toolbar-title>{{ $t('app.title') }}</v-toolbar-title>
    -->

    <!-- slot to inject components after the title text -->
    <slot name="wgu-tb-after-title"></slot>

    <!-- TODO experimentell, entscheiden für eine Variante Vorschlag: class="d-none d-sm-flex d-md-none" -->
    <v-menu offset-y nudge-bottom="15">
      <template v-slot:activator="{ on }">
        <v-btn icon v-on="on" class="wgu-menu-button d-sm-flex d-md-none" color="onprimary"
          :title="$t('wgu-toolbar-menu.title')">
          <v-icon medium>menu</v-icon>
        </v-btn>
      </template>
      <v-list color="primary">
        <template>
          <v-list-item>
            <v-btn class="specialFont" outlined color="onprimary" large :class="{ topicActiveColor: topicActive == 'Hochwasser' }"
              @click="topicButtonClicked('Hochwasser')">
              <!--<img class="topicIcon" :title="$t('topic.Hochwasser.title')" src="../static/icon/symbolHochwasser.png" />-->
              <span :class="{ topicActiveTextColor: topicActive == 'Hochwasser' }">{{ $t('topic.Hochwasser.name') }}</span>
            </v-btn>
          </v-list-item>
          <v-list-item>
            <v-btn class="specialFont" outlined color="onprimary" large :class="{ topicActiveColor: topicActive == 'Grundwasser' }"
              @click="topicButtonClicked('Grundwasser')">
              <!--<img class="topicIcon" :title="$t('topic.Grundwasser.title')" src="../static/icon/symbolGrundwasser.png" />-->
              <span :class="{ topicActiveTextColor: topicActive == 'Grundwasser' }">{{ $t('topic.Grundwasser.name') }}</span>
            </v-btn>
          </v-list-item>
          <v-list-item>
            <v-btn class="specialFont" outlined color="onprimary" large :class="{ topicActiveColor: topicActive == 'Starkregen' }"
              @click="topicButtonClicked('Starkregen')">
              <!--<img class="topicIcon" :title="$t('topic.Starkregen.title')" src="../static/icon/symbolStarkregen.png" />-->
              <span  :class="{ topicActiveTextColor: topicActive == 'Starkregen' }">{{ $t('topic.Starkregen.name') }}</span>
            </v-btn>
          </v-list-item>
        </template>
      </v-list>
    </v-menu>

    <!-- Bereich für Topic Buttons-->
    <v-btn class="specialFont adjustPadding buttonBorder d-none d-md-flex" outlined color="onprimary" large
      :class="{ topicActiveColor: topicActive == 'Hochwasser' }" @click="topicButtonClicked('Hochwasser')">
      <!--<img class="topicIcon" :title="$t('topic.Hochwasser.title')" src="../static/icon/symbolHochwasser.png" />-->
      <span class="d-none d-md-flex" :class="{ topicActiveTextColor: topicActive == 'Hochwasser' }">{{ $t('topic.Hochwasser.name') }}</span>
    </v-btn>

    <v-btn class="specialFont adjustPadding buttonBorder d-none d-md-flex" outlined color="onprimary"  large
      :class="{ topicActiveColor: topicActive == 'Grundwasser' }" @click="topicButtonClicked('Grundwasser')">
      <!---<img class="topicIcon" :title="$t('topic.Grundwasser.title')" src="../static/icon/symbolGrundwasser.png" />-->
      <span class="d-none d-md-flex" :class="{ topicActiveTextColor: topicActive == 'Grundwasser' }">{{ $t('topic.Grundwasser.name') }}</span>
    </v-btn>

    <!-- Icon Size Large über media/breakpoint, auf alle Fälle das riesen Padding bei Smartphone weg-->
    <v-btn class="specialFont adjustPadding buttonBorder d-none d-md-flex" outlined color="onprimary"  large
      :class="{ topicActiveColor: topicActive == 'Starkregen' }" @click="topicButtonClicked('Starkregen')">
      <!--<img class="topicIcon" :title="$t('topic.Starkregen.title')" src="../static/icon/symbolStarkregen.png" />-->
      <span class="d-none d-md-flex" :class="{ topicActiveTextColor: topicActive == 'Starkregen' }">{{ $t('topic.Starkregen.name') }}</span>
    </v-btn>
<!--
    <v-fab-transition>
      <template v-for="(tbButton, index) in tbButtonsStarkregenOnly">
        <component class="buttonBorder" v-show="topicActive == 'Starkregen'" :is="tbButton.type" :key="index"
          v-bind="tbButton">Starkregen</component>
      </template>
    </v-fab-transition>
  -->
    <v-fab-transition>
      <template>
        <v-btn class="buttonBorder adjustPadding" v-show="topicActive == 'Starkregen'" elevation="0" @click="show3D" text
          color="onprimary" large>
          <v-icon color="onprimary">$vuetify.icons.IconThreeD</v-icon>
          <span>&nbsp;Ansicht</span>
        </v-btn>
      </template>
    </v-fab-transition>

    <v-spacer></v-spacer>

    <!-- slot to inject components before the auto-generated buttons (by config) -->
    <slot name="wgu-tb-before-auto-buttons"></slot>

    <template v-for="(tbButton, index) in tbButtons">
      <component :is="tbButton.type" :key="index" x-large v-bind="tbButton" />
    </template>

    <!-- slot to inject components after the auto-generated buttons (by config) -->
    <slot name="wgu-tb-after-auto-buttons"></slot>

    <v-menu v-if="menuButtons.length" offset-y nudge-bottom="15">
      <template v-slot:activator="{on}">

        <v-btn icon v-on="on" class="wgu-menu-button" color="onprimary" :title="$t('wgu-toolbar-menu.title')">
          <v-icon medium>menu</v-icon>
        </v-btn>
      </template>
      <v-list color="primary">
        <template v-for="(tbButton, index) in menuButtons">
          <v-list-item :key="index">
            <component :is="tbButton.type" :key="index" v-bind="tbButton" />
          </v-list-item>
        </template>
      </v-list>
    </v-menu>

    <!-- slot to inject components at the end of the toolbar (after menu) -->
    <slot name="wgu-tb-end"></slot>

    <!-- Steb Logo -->
    <a href="https://steb-koeln.de" class="logo" target="_blank">
      <img :src=logo style="height: 100%" />
    </a>

  </v-app-bar>
</template>

<script>

import Vue from 'vue'
import ToggleButton from '../../src/components/modulecore/ToggleButton'
import ZoomToMaxExtentButton from '../../src/components/maxextentbutton/ZoomToMaxExtentButton'
import Geocoder from '../../src/components/geocoder/Geocoder'
import Geolocator from '../../src/components/geolocator/Geolocator'
import LocaleSwitcher from '../../src/components/localeswitcher/LocaleSwitcher'
import ThemeSwitcher from '../../src/components/themeswitcher/ThemeSwitcher'
// import Button3D from './3DButton/3DButton'
import WRCLink from './WRCLink/WRCLink.vue'
import InfoButton from './InfoButton/InfoButton.vue'
import { WguEventBus } from '../../src/WguEventBus'

export default {
  name: 'wgu-app-header',
  components: {
    'wgu-toggle-btn': ToggleButton,
    'wgu-geocoder-btn': Geocoder,
    'wgu-zoomtomaxextent-btn': ZoomToMaxExtentButton,
    'wgu-geolocator-btn': Geolocator,
    'wgu-localeswitcher-btn': LocaleSwitcher,
    'wgu-themeswitcher-btn': ThemeSwitcher,
    // 'wgu-3dButton-btn': Button3D,
    'wgu-WRCLink-btn': WRCLink,
    'wgu-infobutton-btn': InfoButton
  },
  computed: {
    headerheight () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return 64;
        case 'sm': return 64;
        case 'md': return 74;
      }

      return 74;
    }
  },
  props: {},
  data () {
    const urlObj = new URL(window.location.href)

    if (urlObj.searchParams.get('Module')) {
      if (this.$appConfig.TopicList.indexOf(urlObj.searchParams.get('Module')) >= 0) {
        this.$appConfig.TopicDefault = urlObj.searchParams.get('Module')
      }
    }

    return {
      menuButtons: this.getModuleButtons('menu'),
      tbButtons: this.getModuleButtons('toolbar'),
      tbButtonsStarkregenOnly: this.getModuleButtons('toolbarStarkregenOnly'),
      topicActive: this.$appConfig.TopicDefault,
      logo: this.$appConfig.logoHeader
    }
  },
  methods: {
    /**
     * Determines the module button configuration objects from app-config:
     * If the module button toggles a window, then a generic wgu-toggle-btn will
     * be returned - otherwise the button is custom.
     *
     *    menuButtons: [
     *      {type: 'wgu-layerlist-toggle-btn'},
     *      {type: 'wgu-helpwin-toggle-btn'},
     *      {type: 'wgu-measuretool-toggle-btn'}
     *    ]
     * @param  {String} target Either 'menu' or 'toolbar'
     * @return {Array} module button configuration objects
     */
    hideAllOther () {
      WguEventBus.$emit('wgu-3d-button-visibility-change', false);
      WguEventBus.$emit('wgu-impressum-visibility-change', false);
      WguEventBus.$emit('wgu-datenschutz-visibility-change', false);
      WguEventBus.$emit('wgu-rechtlichehinweise-visibility-change', false);
    },
    show3D () {
      this.hideAllOther();
      WguEventBus.$emit('wgu-3d-button-visibility-toggle', true);
    },

    getModuleButtons (target) {
      const appConfig = Vue.prototype.$appConfig || {};
      const modulesConfs = appConfig.modules || {};
      const buttons = [];
      for (const key of Object.keys(modulesConfs)) {
        const moduleOpts = appConfig.modules[key];

        if (moduleOpts.target === target ||
             (target === 'menu' && moduleOpts.target === 'toolbar_onsmall_menu' && moduleOpts.breakpoint && moduleOpts.breakpoints_for_menu.includes(this.$vuetify.breakpoint.name)) ||
             (target === 'toolbar' && moduleOpts.target === 'toolbar_onsmall_menu' && moduleOpts.breakpoints_for_menu && !moduleOpts.breakpoints_for_menu.includes(this.$vuetify.breakpoint.name))
        ) {
          buttons.push({
            type: moduleOpts.win ? 'wgu-toggle-btn' : key + '-btn',
            moduleName: key,
            ...moduleOpts
          });
        }
      }
      return buttons;
    },
    topicButtonClicked (t) {
      // console.log('Topicbutton clicked');
      // console.log(t);

      this.topicActive = t;

      WguEventBus.$emit('layerList-topicButton', t);
      WguEventBus.$emit('infoButton-topicButton', t);
      WguEventBus.$emit('flyerWindow-topicButton', t);
    }
  }
}
</script>

<style>

.v-btn {
  text-transform: none;
  letter-spacing: 0.12em;
}

.adjustPadding {
  margin-left: 4px;
  margin-right: 4px;
}

@media (min-width: 960px) {
  .v-toolbar__content {
    padding-top: 10px;
    padding-bottom: 10px;
  }
}

@media (max-width: 1264px) {
  .wgu-app-toolbar .v-toolbar__content {
    padding-right: 4px !important;
    padding-left: 40px !important; /* beim Wechsel der Sidebar Abstand vergrößern */
  }
  .adjustPadding {
    padding: 0 8px !important;
    letter-spacing: 0px;
    margin-left: 2px;
    margin-right: 2px;
    min-width: 50px !important;
  }
  .v-toolbar__content .v-btn.v-btn--icon.v-size--default {
    width: 36px !important;
  }
  .v-btn-toggle .v-btn.v-btn.v-size--default {
    width: 36px !important;
    min-width: 36px !important;
  }
}

@media (max-width: 600px) {
  .v-toolbar__content .v-btn.v-btn--icon.v-size--default {
    width: 30px !important;
  }
  .v-btn-toggle .v-btn.v-btn.v-size--default {
    width: 30px !important;
    min-width: 30px !important;
  }
}

</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.logo {
  margin-left: 30px;
  height: 70%;
}

@media (min-width: 960px) {
  .buttonBorder {
    /* border: solid 1px #0061A0 !important; */
    border: solid 2px #00508c !important;
    margin-left: 4px !important;
  }

}
@media (max-width: 960px) {
  .buttonBorder {
    /* border: solid 1px #0061A0 !important; */
    border: solid 2px #00508c !important;
    margin-left: 0px !important;
  }
}

@media (max-width: 1450px) {
  .adjustPadding {
    padding: 0 10px !important;
    letter-spacing: 1px;
  }
}

@media (max-width: 1200px) {
  .adjustPadding {
    padding: 0 8px !important;
    letter-spacing: 0px;
    margin-left: 2px;
    margin-right: 2px;
  }

  .logo {
    margin-left: 12px;
  }
}

@media (max-width: 1000px) {
  .adjustPadding {
    padding: 0 8px !important;
    letter-spacing: -1px;
    margin-left: 2px;
    margin-right: 2px;
  }

  .logo {
    margin-left: 4px;
    height: 50%;
  }
}

@media (max-width: 800px) {
  .adjustPadding {
    padding: 0 4px !important;
    min-width: 0px !important;
    margin-left: 1px;
    margin-right: 1px;
  }

  .logo {
    margin-left: 0px;
    height: 40%;
  }

}

@media (max-width: 600px) {
  .adjustPadding {
    padding: 0 4px !important;
    min-width: 0px !important;
    margin-left: 1px;
    margin-right: 1px;
  }
}

@media (max-width: 550px) {
  .logo { /* wenn Buttons reduziert werden kann Logo bleiben */
    margin-left: 0px;
    display: none;
  }
}

@media (max-width: 480px) {
  .adjustPadding {
    padding: 0 4px !important;
    min-width: 0px !important;
    margin-left: 1px;
    margin-right: 1px;
  }

  .logo {
    margin-left: 0px;
    display: none;
  }
}

</style>
